export enum LeadActivityEnum {
  LeadCreated = 1,
  SourceChanged = 2,
  SubSourceChanged = 3,
  PipelineChanged = 4,
  StageChanged = 5,
  AssigneeChanged = 6,
  PriorityChanged = 7,
  TagChanged = 9,
  ExistingLead = 10,
  Notes = 11,
  Log = 12,
  Tasks = 13,
  SiteVisit = 14,
  DiscountRequest = 16,
  Customer = 17,
  LeadRequest = 18,
  Communication = 19
}
